import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { ContactusService } from '../../_services/contactus.service';
import {environment} from "../../../environments/environment";
import { ToasterService } from '../../_services/toaster.service';
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

declare var $: any;

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {
  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  subscribeList: any;
  patients_data: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private contactusservice: ContactusService, private toaster: ToasterService,private excelService:ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getAllSubscriptions();
  }
  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.patients_data, 'customers_popup');
    this.spinnerService.hide();
  }
  getAllSubscriptions() {
    this.contactusservice.getAllSubscriptions()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.subscribeList = data.subscribeList;

            this.subscribeList.forEach((row: any) => {
              const userdata = {
                Name: (['name'])?row['name']:'',
                Email: (['email'])?row['email']:'',
                offer: (['offer'])?row['offer']:'',
                Mobile: (['phone'])?row['phone']:'',
                isRegistered: (['isRegistered'])?row['isRegistered']:'',
              };
              this.patients_data.push(userdata);
            });


            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('subscribeList', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

}
